<template>
  <div v-loading="loading">
    <el-calendar>
      <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
      <template slot="dateCell" slot-scope="{date, data}">
        <el-popover
          placement="bottom"
          :title="data.day"
          width="400"
          trigger="click"
          :ref="'del-'+data.day"
        >
          <ul class="tips-content" v-if="popoverShow" v-loading="loading">
            <li>
              上课时间：
              <el-time-picker v-model="startDate" placeholder="请选择上课时间" value-format="HH:mm"></el-time-picker>
            </li>
            <li>
              下课时间：
              <el-time-picker v-model="endDate" placeholder="请选择下课时间" value-format="HH:mm"></el-time-picker>
            </li>
            <li>
              上课地点：
              <el-input v-model="place" placeholder="请输入上课地点" style="width:260px"></el-input>
            </li>
            <li style="text-align: center">
              <el-button size="small" @click="saveSub(data.day,'cancel')">取消</el-button>
              <el-button type="primary" size="small" @click="saveSub(data.day,'save')">确认</el-button>
            </li>
          </ul>
          <div v-else>
            <ul class="calendarCen">
              <li
                v-for="(subItem, subIndex) in dealMyDate(data.day)"
                :key="subIndex"
                class="calendarLi"
              >
                <div style="flex: 1;">
                  <p>时间:{{subItem.startDate.split(' ').slice(0,2)[1]}}~{{subItem.endDate.split(' ').slice(0,2)[1]}}</p>
                  <p>地点:{{subItem.place}}</p>
                </div>
                <p>
                  <i
                    class="el-icon-delete"
                    style="font-size: 20px;color: red;cursor: pointer;"
                    @click="delKnobble(subItem)"
                  ></i>
                </p>
              </li>
            </ul>
            <el-button @click="addCalenar">添加课程</el-button>
          </div>

          <div slot="reference" class="reference" @click="calendarInit(data.day)">
            <p>{{ data.day.split('-').slice(1).join('-') }}</p>
            <p
              v-for="(subItem, subIndex) in dealMyDate(data.day)"
              :key="subIndex"
            >{{subItem.startDate.split(' ').slice(0,2)[1]}}~{{subItem.endDate.split(' ').slice(0,2)[1]}}</p>
          </div>
        </el-popover>
      </template>
    </el-calendar>
  </div>
</template>

<script>
export default {
  props: {
    calendar: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      popoverShow: false,
      loading: false,
      startDate: "",
      endDate: "",
      place: "",
      resDate: [],
      saveParam: {
        courseId: this.calendar.courseId,
        courseSectionTOList: [
          {
            endDate: "",
            place: "",
            remark: "",
            startDate: ""
          }
        ],
        schoolId: this.calendar.schoolId,
        teacherId: this.calendar.teacherId
      }
    };
  },
  methods: {
    // 删除小节
    delKnobble(row) {
      this.$confirm("您确认删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const param = {
          schoolId: this.calendar.schoolId,
          sectionId: row.sectionId
        };
        this.loading = true;
        this.$api.allianceSchool.delCourseSection(param).then(res => {
          this.loading = false;
          if (res.errCode == 0) {
            this.$message.success("删除成功！");
            this.initData(this.calendar);
          } else {
            this.$message.error(res.errMsg);
          }
        }).catch(res=>{
        this.loading = false;
      });;
      });
    },
    // 添加课程
    addCalenar() {
      this.startDate = "";
      this.endDate = "";
      this.place = "";
      this.popoverShow = true;
    },
    dealMyDate(v) {
      let len = this.resDate.length;
      let res = [];
      for (let i = 0; i < len; i++) {
        if (this.resDate[i].startDate.split(" ").slice(0, 2)[0] == v) {
          // res[i] = this.resDate[i];
          res = this.resDate.filter(
            item => item.startDate.split(" ").slice(0, 2)[0] == v
          );
          // res.push(this.resDate[i])
          break;
        }
      }
      this.calendarData = res;
      return res;
    },
    calendarInit(res) {
      const dealData = this.dealMyDate(res);
      this.popoverShow = false;
      this.$refs["del-" + res].doShow;
    },
    saveSub(item, type) {
      if (type == "cancel") {
        this.$refs["del-" + item].doClose();
      } else {
        if (!this.startDate || !this.endDate || !this.place) {
          this.$message.error("时间或地点不能为空");
          return;
        }
        this.saveParam.courseSectionTOList[0].startDate = this.startDate
          ? item.concat(" " + this.startDate)
          : "";
        this.saveParam.courseSectionTOList[0].endDate = this.endDate
          ? item.concat(" " + this.endDate)
          : "";
        this.saveParam.courseSectionTOList[0].place = this.place;
        this.saveParam.courseId = this.calendar.courseId,
        this.$api.allianceSchool.setCourseSection(this.saveParam).then(res => {
          if (res.errCode == 0) {
            this.initData(this.calendar);
            this.$refs["del-" + item].doClose();
          } else {
            this.$message.error(res.errMsg);
          }
        });
      }
    },
    // 初始化数据
    initData(param) {
      this.loading = true;
      this.$api.allianceSchool.getCourseSection(param).then(res => {
        this.loading = false;
        if (res.errCode == 0) {
          this.resDate = res.data || [];
        } else {
          this.$message.error(res.errMsg);
        }
      }).catch(res=>{
        this.loading = false;
      });
    }
  },
  created() {
    // this.search();
  },
  mounted() {}
};
</script>
<style lang='less' scoped>
.is-selected {
  color: #1989fa;
}
.reference {
  width: 100%;
  min-height: 67px;
  overflow: auto;
  height: 79px;
}
.tips-content {
  li {
    margin: 10px 0 10px 0;
  }
}
.calendarLi {
  line-height: 22px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-bottom: 1px solid #ccc;
}
.calendarCen {
  overflow: auto;
  max-height: 300px;
  margin-bottom: 10px;
}
</style>